// extracted by mini-css-extract-plugin
module.exports = {"AdminDecors":"adminDecors_AdminDecors__2GeyV"};